/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAImportIcon16Solid = forwardRef('ArrowUiShareAImportIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1A3.5 3.5 0 0 0 4 4.5V7a2 2 0 0 1-2-2V3.75a1 1 0 0 0-2 0V5a4 4 0 0 0 4 4v2.5A3.5 3.5 0 0 0 7.5 15h5a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 12.5 1h-5ZM4 9V7h6.153L8.405 5.37A1 1 0 0 1 9.77 3.907l2.82 2.63a2 2 0 0 1 0 2.926l-2.82 2.63a1 1 0 1 1-1.365-1.462L10.153 9H4Z" })));
});
